export default [
  function smartImg() {
    return {
      restrict: 'A',
      link: (scope, el, attrs) => {
        let $el = $(el[0]);
        let $spin = $('<div class="smart-img-spinner"></div>');
        $el.before($spin);

        $el.attr('src', attrs.placeholderImg).addClass('smart-img-loading');

        scope.$watch(() => attrs.smartImg, (newImg) => {
          $el.attr('src', attrs.placeholderImg).addClass('smart-img-loading');
          $spin.show();

          let i = new Image();
          i.onload = () => {
            $el.attr('src', newImg).removeClass('smart-img-loading');
            $spin.hide();
            scope.$emit('smart-img:loaded');
          }
          i.src = newImg;
        });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/smart-img/smart-img.dir.js